module.exports = __webpack_public_path__ + "static/media/timothy-henry.daf8e986.jpg";